import { useEffect, useState } from 'react';

// Tracks whether a CSS media query matches. (Local replacement for
// react-use/lib/useMedia.)
export default function useMedia(query: string, defaultState = false) {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : defaultState,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined;
    }
    const mql = window.matchMedia(query);
    const onChange = () => {
      setMatches(mql.matches);
    };
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => {
      mql.removeEventListener('change', onChange);
    };
  }, [query]);

  return matches;
}
